// extracted by mini-css-extract-plugin
export default {"modalBody":"MobileModal_modalBody__PauyI","detailsLogo":"MobileModal_detailsLogo__0Ki+T","modal":"MobileModal_modal__A0o-M","mobileText":"MobileModal_mobileText__Py+Dj"};